import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import {
  IntegrationEnum,
  PropertiesActivityResponseTO,
} from 'models/InternalIntegrationSetting';
import API from 'services/API';
import { INTERNAL_INTEGRATION_SETTINGS_BASE_QUERY_KEY } from 'pages/channels/integrationSettingsQuery';

type ReactQueryOptions = Omit<
  UseQueryOptions<PropertiesActivityResponseTO>,
  'queryKey' | 'queryFn'
>;

type UseFetchPropertiesActivityArgs = {
  enumId: IntegrationEnum;
} & ReactQueryOptions;

export const PROPERTIES_ACTIVITY_QUERY_KEY = 'properties-activity';

export const getPropertiesActivityQueryKey = ({
  enumId,
}: {
  enumId: IntegrationEnum;
}) => [
  INTERNAL_INTEGRATION_SETTINGS_BASE_QUERY_KEY,
  PROPERTIES_ACTIVITY_QUERY_KEY,
  { enumId },
];

const useFetchPropertiesActivity = ({
  enumId,
  enabled = true,
  ...options
}: UseFetchPropertiesActivityArgs) => {
  return useAppQuery<PropertiesActivityResponseTO>({
    queryKey: getPropertiesActivityQueryKey({ enumId }),
    queryFn: async () => {
      const response = await API.get<PropertiesActivityResponseTO>(
        `/api/internal/integrations/default/${enumId}/properties-activity`,
      );

      return response.data;
    },
    enabled,
    staleTime: 30000,
    ...(options ?? {}),
  });
};

export default useFetchPropertiesActivity;
